import React, { useState } from 'react';
import { X, CheckCircle } from 'lucide-react';
import { useUser } from '../UserContext';
interface EmailUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const EmailUpdateModal = ({
  isOpen,
  onClose
}: EmailUpdateModalProps) => {
  const {
    userData,
    updateUserData
  } = useUser();
  const [newEmail, setNewEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Reset error state
    setError('');
    // Basic validation
    if (!newEmail || !password) {
      setError('Lütfen tüm alanları doldurunuz.');
      return;
    }
    if (!newEmail.includes('@') || !newEmail.includes('.')) {
      setError('Geçerli bir e-posta adresi giriniz.');
      return;
    }
    // Simulate API call
    setTimeout(() => {
      updateUserData({
        email: newEmail
      });
      setIsSuccess(true);
      // Reset form
      setNewEmail('');
      setPassword('');
      // Close modal after success
      setTimeout(() => {
        onClose();
        setIsSuccess(false);
      }, 2000);
    }, 1000);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 flex items-center justify-center z-50" data-id="element-1390">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-1391"></div>
      <div className="relative bg-black/90 border border-emerald-500/30 shadow-[0_0_25px_rgba(16,185,129,0.2)] rounded-lg w-full max-w-md mx-4 overflow-hidden" data-id="element-1392">
        {isSuccess ? <div className="p-6 flex flex-col items-center" data-id="element-1393">
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mb-4" data-id="element-1394">
              <CheckCircle className="h-8 w-8 text-emerald-500" data-id="element-1395" />
            </div>
            <h3 className="text-xl font-bold text-center mb-2" data-id="element-1396">
              E-posta Başarıyla Güncellendi
            </h3>
            <p className="text-gray-400 text-center" data-id="element-1397">
              Yeni e-posta adresiniz başarıyla kaydedildi.
            </p>
          </div> : <>
            <div className="flex justify-between items-center p-6 border-b border-gray-800" data-id="element-1398">
              <h3 className="text-lg font-bold" data-id="element-1399">E-posta Güncelle</h3>
              <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1400">
                <X className="h-5 w-5" data-id="element-1401" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="p-6" data-id="element-1402">
              {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-500/30 text-red-400 rounded-md text-sm" data-id="element-1403">
                  {error}
                </div>}
              <div className="space-y-4" data-id="element-1404">
                <div data-id="element-1405">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1406">
                    Mevcut E-posta
                  </label>
                  <input type="email" value={userData.email} disabled className="w-full bg-black/20 text-gray-400 rounded-lg px-4 py-2 cursor-not-allowed" data-id="element-1407" />
                </div>
                <div data-id="element-1408">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1409">
                    Yeni E-posta
                  </label>
                  <input type="email" value={newEmail} onChange={e => setNewEmail(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-gray-700 focus:border-emerald-500" placeholder="yeni.email@example.com" data-id="element-1410" />
                </div>
                <div data-id="element-1411">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1412">
                    Şifreniz
                  </label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-gray-700 focus:border-emerald-500" placeholder="Güvenlik için şifrenizi girin" data-id="element-1413" />
                </div>
                <div className="pt-4 flex justify-end space-x-3" data-id="element-1414">
                  <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg" data-id="element-1415">
                    İptal
                  </button>
                  <button type="submit" className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 rounded-lg" data-id="element-1416">
                    E-postayı Güncelle
                  </button>
                </div>
              </div>
            </form>
          </>}
      </div>
    </div>;
};